/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { Button, MenuItem, Menu } from '@material-ui/core';
import { HiOutlineDotsVertical } from '@react-icons/all-files/hi/HiOutlineDotsVertical';
import { RiHome5Line } from '@react-icons/all-files/ri/RiHome5Line';
import { BiBriefcase } from '@react-icons/all-files/bi/BiBriefcase';
import { RiHotelLine } from '@react-icons/all-files/ri/RiHotelLine';
import { GoLocation } from '@react-icons/all-files/go/GoLocation';
const { selectDesktop } = Slices.appSlice;
import { FormattedMessage, useIntl } from 'react-intl';
const { setCloseEditAddressPopup } = Slices.addressSlice;

// import ClassNames from 'classnames';
import css from './index.module.scss';
const AddressItem = ({ itemData, onSelect, onDelete, showAction, myAddress }) => {
  const navigate = useNavigate();
  const { isEditAdressPopupOpen } = useSelector((state) => state.address);
  const intl = useIntl();
  const location = useLocation();
  const isDesktop = useSelector(selectDesktop);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleDelete = () => {
    setAnchorEl(null);
    onDelete();
  };
  const ITEM_HEIGHT = 48;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const iconList = {
    HOME: <RiHome5Line />,
    HOTEL: <RiHotelLine />,
    OFFICE: <BiBriefcase />,
    OTHER: <GoLocation />,
  };
  const handleEdit = (event, id) => {
    event.preventDefault();
    // SET TO TRUE IF EDIT POPUP NOT OPEN
    if (!isEditAdressPopupOpen) {
      dispatch(setCloseEditAddressPopup(true));
    }

    if (isDesktop) {
      if (myAddress) {
        navigate(
          `${
            location.state.oldLocation?.pathname || location?.pathname
          }?modal=editaddress&addId=${id}`
        );
      } else {
        if (location?.href?.indexOf('bundleGroup') > -1) {
          let returnUrl = location?.search?.split('&modal')?.[0];
          navigate(`${location?.pathname}${returnUrl}&modal=editaddress&addId=${id}`);
        } else {
          navigate(`${location?.pathname}?modal=editaddress&addId=${id}`);
        }
      }
    } else {
      navigate(`/${intl.locale}/editAddress/${id}`);
    }
  };
  return (
    <>
      <div key={itemData.bldgName + '-' + itemData.id} className={css.addressItem}>
        <div className={css.addressIcon} onClick={onSelect}>
          {iconList[itemData.tag]}
        </div>
        <div className={css.detail} onClick={onSelect}>
          <h3>{intl.formatMessage({ id: `addressSelector_tag_${itemData.tag}` })}</h3>
          <p>
            {itemData.bldgName}, {itemData.flatNum}
            {itemData.description}
          </p>
        </div>

        {showAction && (
          <div className={css.action}>
            <Button
              id="demo-customized-button"
              aria-controls={open ? 'demo-customized-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              variant="outlined"
              disableElevation
              onClick={handleClick}
              className={css.addressMenu}
            >
              <HiOutlineDotsVertical color="black" className={css.HiOutlineDotsVerticalCss} />
            </Button>
            <Menu
              style={{ zIndex: 1500 }}
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                  zIndex: '1500',
                },
              }}
            >
              <MenuItem key={1} onClick={(event) => handleEdit(event, itemData.id)}>
                <span className={css.editText}>
                  <FormattedMessage id="addresslist_edit_capital" defaultMessage="EDIT" />
                </span>
              </MenuItem>
              <MenuItem key={2} onClick={handleDelete}>
                <span className={css.deleteText}>
                  <FormattedMessage id="addresslist_delete_capital" defaultMessage="DELETE" />
                </span>
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </>
  );
};

export default AddressItem;
